import { FOOTER_CONTENT, NAV_LINKS, SOCIAL_LINKS } from "../../data/siteData";
import "./Footer.css";

function FacebookIcon() {
  return (
    <svg
      className="footer__social-icon"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M13.5 21v-8.06h2.71l.4-3.14h-3.11V7.9c0-.91.25-1.53 1.56-1.53h1.67V3.56C15.91 3.48 15.03 3.4 14 3.4c-2.2 0-3.71 1.34-3.71 3.8v2.6H7.57v3.14h2.72V21h3.21z" />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg
      className="footer__social-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="3" y="3" width="18" height="18" rx="5" ry="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.2" cy="6.8" r="1.1" fill="currentColor" stroke="none" />
    </svg>
  );
}

function TikTokIcon() {
  return (
    <svg
      className="footer__social-icon"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M16.5 3c.4 2.1 1.7 3.5 3.9 3.7v3.1c-1.4.1-2.7-.3-3.9-1.1v6.4c0 3.2-2.6 5.9-5.9 5.9S4.7 18.3 4.7 15c0-3.1 2.4-5.6 5.4-5.9v3.2c-1.3.3-2.3 1.5-2.3 2.9 0 1.6 1.3 2.9 2.9 2.9s2.9-1.3 2.9-2.9V3h3z" />
    </svg>
  );
}

/* ============================================================
   CONTACT ICONS (location pin, phone, envelope)
============================================================ */

function LocationIcon() {
  return (
    <svg
      className="footer__contact-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M12 22s7-7.58 7-12.5A7 7 0 0 0 5 9.5C5 14.42 12 22 12 22z" />
      <circle cx="12" cy="9.5" r="2.4" />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg
      className="footer__contact-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M6.6 10.8c1.4 2.8 3.8 5.2 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.4c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.4 0 .8-.3 1.1l-2.1 2.1z" />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg
      className="footer__contact-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="3" y="5" width="18" height="14" rx="2.5" />
      <path d="M3.5 6.5 12 13l8.5-6.5" />
    </svg>
  );
}

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__grid">
        <div className="footer__brand">
          <span className="footer__logo-mark">yc</span>
          <h4 className="footer__logo-name">YOUR CARE</h4>
          <p className="footer__logo-tag">Care that Clicks</p>
          <p className="footer__desc">{FOOTER_CONTENT.description}</p>
          <div className="footer__socials">
            <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer" aria-label="Follow us on Facebook">
              <FacebookIcon />
            </a>
            <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Follow us on Instagram">
              <InstagramIcon />
            </a>
            <a href={SOCIAL_LINKS.tiktok} target="_blank" rel="noopener noreferrer" aria-label="Follow us on TikTok">
              <TikTokIcon />
            </a>
          </div>
        </div>

        <div className="footer__col">
          <h5>Quick Links</h5>
          <ul>
            {NAV_LINKS.map((l) => (
              <li key={l.path}>
                <a href={l.path}>{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer__col">
          <h5>Get In Touch</h5>
          {/* All three rows are wrapped in footer__contact-group so
              they center as ONE block on mobile, instead of each
              row centering itself. This keeps the pin/phone/mail
              icons on the same vertical line regardless of text
              length. See Footer.css for the matching rules. */}
          <div className="footer__contact-group">
            <p className="footer__contact-item">
              <LocationIcon />
              <span>{FOOTER_CONTENT.address}</span>
            </p>
            <p className="footer__contact-item">
              <PhoneIcon />
              <span>{FOOTER_CONTENT.phone}</span>
            </p>
            <p className="footer__contact-item">
              <MailIcon />
              <span>{FOOTER_CONTENT.email}</span>
            </p>
          </div>
        </div>

        <div className="footer__col footer__qr">
          <h5>Scan QR Code</h5>
          <img src={FOOTER_CONTENT.qrImage} alt="Scan to visit YourCare" />
        </div>
      </div>

    <p className="footer__copy">
      © {FOOTER_CONTENT.year} Your Care. All rights reserved.{" "}
      <span> | </span>
      <a
        href="https://it.swiftsignbm.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Swift Sign IT & Cyber Solutions
      </a>
    </p>

    </footer>
  );
}

export default Footer;